import api from "./apiClient.js";

const endpoint = "sensors";

export const getAllSensors = () => {
	return api.get(endpoint);
};

export const getSensorDataByCode = (code) => {
	return api.get(endpoint + "/" + code);
};

export const getSensorDataByCodeArray = (codes) => {
	const queryParam = codes.join(",");
	return api.get(`${endpoint}/code?codes=${queryParam}`);
};
